import { linkOptions } from "@tanstack/react-router";

/**
 * Where a profile lives: `/@username` once it has claimed a username, and `/profiles/<id>` until
 * then. Spread into a `Link`.
 */
export function profileLink(profile: { profileId: string; username: string | null }) {
  return profile.username
    ? linkOptions({ to: "/@{$username}", params: { username: profile.username } })
    : linkOptions({ to: "/profiles/$profileId", params: { profileId: profile.profileId } });
}
